export const MAIN_SERVER = 'https://sitiy-api.ru';
export const TEST_SERVER = 'https://sitiy-api-test.ru';
export const LOCAL_SERVER = 'https://localhost';

export const resolveDefaultServerByHostname = (hostname) => {
  const currentHostname = hostname || (typeof window !== 'undefined' ? window.location.hostname : '');

  if (
    currentHostname === 'sitiy-test.ru' ||
    currentHostname === 'dev.sitiy.ru' ||
    currentHostname === 'localhost'
  ) {
    return TEST_SERVER;
  }

  return MAIN_SERVER;
};

export const resolveCurrentServer = (storedServer, hostname) => {
  if (storedServer && typeof storedServer === 'string') {
    return storedServer;
  }

  return resolveDefaultServerByHostname(hostname);
};